import { Form, FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import { Button, FormikInput, FormikInputPassword } from '@febos-io/design';

import { Link } from 'react-router-dom';
import { amplifySignIn, useTranslation } from '../hooks';
import configureSignInSchema from '../schemas/configureSignInSchema';
import { useAuthContext } from '../providers';
import PasswordRequirements from './PasswordRequirements';

export function UserSignInForm() {
  const [enabledButton, setEnabledButton] = useState(true);

  const {
    changePasswordPathname
  } = useAuthContext();
  const { t } = useTranslation();
  const {
    loading,
    isNewPasswordRequired,
    onSubmit,
    onSignInFederate
  } = amplifySignIn.useSignIn();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      newPassword: ''
    },
    validationSchema: configureSignInSchema(isNewPasswordRequired),
    onSubmit: onSubmit
  });

  return (
    <>
      <FormikProvider value={formik}>
        <Form
          className="auth-login-form mt-2"
        >
          <FormikInput
            name="email"
            label={t('Email')}
            type="email"
            placeholder="user@example.com"
            icon="user"
            className="mb-1"
          />
          <FormikInputPassword
            name="password"
            label={!isNewPasswordRequired ? t('Password') : t('New Password')}
            type="password"
            icon="lock"
            className="mb-1"
          >
            {!isNewPasswordRequired && (
              <Link to={changePasswordPathname}>
                <small>{t('Did you forget your password?')}</small>
              </Link>
            )}
          </FormikInputPassword>
          {isNewPasswordRequired && (
            <>
              <FormikInput
                name="newPassword"
                label={t('Confirm Password')}
                type="password"
                icon="lock"
                className="mb-1"
              />
              <PasswordRequirements
                password={formik.values.password}
                setEnabledButton={setEnabledButton}
              />
            </>
          )}
          <div className="d-grid">
            <Button
              type="submit"
              loading={loading}
              disabled={isNewPasswordRequired ? enabledButton : false}
            >
              {t(!isNewPasswordRequired ? 'Sign in' : 'Change password')}
            </Button>
          </div>
        </Form>
      </FormikProvider>
      {!isNewPasswordRequired && (
        <>
          <div className="divider my-2">
            <div className="divider-text">
              {t('or sign-in with')}
            </div>
          </div>
          <div className="justify-content-center">
            <Button
              onClick={() => onSignInFederate('Google')}
              loading={loading}
              className="btn-google"
            >
              {t('Google')}
            </Button>
          </div>
        </>
      )}
    </>
  );
}

UserSignInForm.propTypes = {
};

export default UserSignInForm;
